import React from 'react';
import { Table, Badge } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';
import { useAppTheme } from '../../../contexts/ThemeContext';
import { getTableHeaderClass, getModernTableClass } from 'utils/tableTheme';

const VolumeDiscountTable = ({
  tiers,
  selectedQuantity,
  formatMoney,
  unitPrice = 0,
  onSelectTier,
  disabled = false,
}) => {
  const currentTheme = useAppTheme();

  return (
    <Table
      responsive
      hover
      size="sm"
      className={`mb-0 ${getModernTableClass(currentTheme)}`}
    >
      <thead>
        <tr className={`${getTableHeaderClass(currentTheme)} text-center`}>
          <th style={{ width: 48 }} />
          <th>Volume</th>
          <th>Quantidade</th>
          <th>Desconto por volume</th>
          <th>Valor unit. c/ desconto*</th>
        </tr>
      </thead>
      <tbody>
        {tiers.map((tier) => {
          const isSelected = selectedQuantity === tier.quantity;
          const unitWithVolume = formatMoney(
            unitPrice * (1 - tier.volumeDiscountPercent / 100)
          );

          return (
            <tr
              key={tier.quantity}
              className={isSelected ? 'table-success' : ''}
              style={{ cursor: disabled ? 'default' : 'pointer' }}
              onClick={() => !disabled && onSelectTier(tier.quantity)}
            >
              <td className="text-center align-middle">
                {isSelected ? (
                  <FaCheckCircle className="text-success" />
                ) : (
                  <span className="text-muted">○</span>
                )}
              </td>
              <td className="align-middle">
                <div className="fw-semibold">{tier.label}</div>
                <small className="text-muted">{tier.description}</small>
              </td>
              <td className="text-center align-middle">{tier.quantity}</td>
              <td className="text-center align-middle">
                <Badge bg={tier.volumeDiscountPercent > 0 ? 'success' : 'secondary'}>
                  {tier.volumeDiscountPercent}%
                </Badge>
              </td>
              <td className="text-center align-middle fw-semibold">
                {unitWithVolume}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default VolumeDiscountTable;
